import type { Action } from 'redux'

import slice from './qr-code.slice'
import { moduleName } from './qr-codes.types'

export const actionTypes = {
  DOWNLOAD_QR_CODE: `${moduleName}/DOWNLOAD_QR_CODE`,
}

const downloadQrCode = (): Action => ({
  type: actionTypes.DOWNLOAD_QR_CODE,
})

const {
  setBackgroundColour,
  setCornerDotColour,
  setCornerSquareColour,
  setDotColour,
  setImage,
  setUrl,
  setFilename,
  setBlobUrl,
  clearQrData,
  setBlob,
} = slice.actions

export {
  clearQrData,
  downloadQrCode,
  setBackgroundColour,
  setBlob,
  setBlobUrl,
  setCornerDotColour,
  setCornerSquareColour,
  setDotColour,
  setFilename,
  setImage,
  setUrl,
}
